import saveAs from "file-saver";

import { DATE_FORMATS_FNS } from "components";
import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";
import { formatDate } from "utils/dateHelperFunctions";

type DownloadAppointmentReportPayload = {
  appointment_id: number;
  car_check_ids: number[];
  activity_logs: boolean;
  customer_sign_logs: boolean;
};

export const useDownloadAppointmentReport = () =>
  useTypedMutation<DownloadAppointmentReportPayload, Blob>({
    mutationFn: payload => ApiInstance.post("/pdfs/multiple/download", payload, ENV.appointmentBaseURL, { responseType: "blob" }),
    onSuccess: (_payload, report) => saveAs(report, `Appointment_Report_${formatDate(new Date(), DATE_FORMATS_FNS.monthDayYear)}.pdf`)
  });
